export default __webpack_public_path__ + "static/media/heart-smile.c87b0920.svg";